import { useQuery } from "@tanstack/react-query";
import { getAuthUser } from "@/app/actions/user/get-auth/action";
import { UserStore } from "@/app/stores/UserStore";
import { PublicUser } from "@/app/types/auth/PublicUser";

import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchUser(
  options: { enabled?: boolean; onSuccess?: (user: PublicUser) => void } = {},
) {
  const { enabled = true, onSuccess } = options;
  const setUser = UserStore((state) => state.setUser);

  return useQuery({
    queryKey: [QueryKey.AUTH_USER],
    queryFn: async () => {
      const user = await getAuthUser();

      if (user) {
        setUser(user);
        onSuccess?.(user);
      }

      return user;
    },
    enabled,
    staleTime: Infinity,
  });
}
